import React from 'react';

import Dropdown from './Dropdown';

const SelectType = ({ typeMovement, isFiltered, options, placeHolder, transfer, disabled }) => {

  return (
    <div>
      <Dropdown
        placeholder={placeHolder}
        items={options}
        selectedMovement={typeMovement}
        isFiltered={isFiltered}
        transfer={transfer}
        disabled={disabled}
      />
    </div>
  );
};

export default SelectType;
